import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { MenuItemLinkInput } from '@trackback/widgets';
import { RouterLink } from '@angular/router';
import { MatMenuItem } from '@angular/material/menu';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'tb-menu-item-link',
  imports: [DynamicWidgetDirective, RouterLink, MatMenuItem],
  template: `
    @if (input().external) {
      <a
        mat-menu-item
        [href]="parsedUrl()"
        [class]="parsedStyleClasses()"
        [disabled]="parsedDisabled()"
      >
        @for (child of input().children; track $index) {
          <ng-container [dynamicWidget]="child" [context]="context()" />
        }
      </a>
    } @else {
      <a
        mat-menu-item
        [routerLink]="parsedUrl()"
        [queryParams]="parsedQueryParams()"
        [class]="parsedStyleClasses()"
        [disabled]="parsedDisabled()"
      >
        @for (child of input().children; track $index) {
          <ng-container [dynamicWidget]="child" [context]="context()" />
        }
      </a>
    }
  `,
  styles: `
    tb-menu-item-link {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class MenuItemLinkComponent extends WidgetInputBaseComponent<MenuItemLinkInput> {
  parsedStyleClasses = parsed(this.inputProp('styleClasses'), this.context);
  parsedDisabled = parsed(this.inputProp('disabled'), this.context);
  parsedUrl = parsed(this.inputProp('url'), this.context);
  parsedQueryParams = parsed(this.inputProp('queryParams'), this.context);
}
